import { Box, ClickAwayListener, Fade, Popper, PopperPlacementType } from '@material-ui/core';
import React, { useState } from 'react';

import { getTestAttribute } from '@utils/misc';

import { Button } from '../Button';

import useStyles from './styles';

interface IConfirmationPopperProps {
  successButtonText?: string;
  cancelButtonText?: string;
  placement?: PopperPlacementType;
  onSuccess(): void;
  onCancel?(): void;
  children: any;
}

export const ConfirmationPopper: React.FC<IConfirmationPopperProps> = ({
  onSuccess,
  onCancel = () => {
    /* noop - close only */
  },
  children,
  placement = 'top' as PopperPlacementType,
  successButtonText = 'Zatwierdź',
  cancelButtonText = 'Anuluj',
  ...props
}) => {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = !!anchorEl;
  const id = open ? 'confirmation-popper' : undefined;

  const handleClick = (evt: React.MouseEvent<HTMLElement>) =>
    setAnchorEl(anchorEl ? null : evt.currentTarget);
  const handleClose = () => setAnchorEl(null);

  return (
    <>
      {React.cloneElement(children, {
        onClick: handleClick,
        'aria-describedby': id,
        ...children?.props,
        ...props,
      })}
      <Popper
        className={classes.root}
        transition
        id={id}
        open={open}
        placement={placement}
        anchorEl={anchorEl}
        popperOptions={{
          modifiers: {
            offset: {
              enabled: true,
              offset: '0 5px',
            },
          },
        }}
      >
        {({ TransitionProps }) => (
          <Fade {...TransitionProps} timeout={250}>
            <Box>
              <ClickAwayListener onClickAway={() => setAnchorEl(null)}>
                <Box className={classes.actions}>
                  <Button
                    aria-label="done"
                    color="primary"
                    size="medium"
                    variant="contained"
                    {...getTestAttribute('popper-confirm')}
                    onClick={(evt: React.MouseEvent<any>) => {
                      evt.preventDefault();
                      onSuccess();
                      handleClose();
                    }}
                  >
                    {successButtonText}
                  </Button>
                  <Button
                    className={classes.cancel}
                    aria-label="cancel"
                    color="primary"
                    size="medium"
                    {...getTestAttribute('popper-cancel')}
                    variant="outlined"
                    onClick={(evt: React.MouseEvent<any>) => {
                      evt.preventDefault();
                      onCancel && onCancel();
                      handleClose();
                    }}
                  >
                    {cancelButtonText}
                  </Button>
                </Box>
              </ClickAwayListener>
            </Box>
          </Fade>
        )}
      </Popper>
    </>
  );
};
